export default __webpack_public_path__ + "static/media/hm10.0874b68d.png";